import type { NewsCategory, NewsItem } from "@/types";

export const NEWS_CATEGORY_LABEL: Record<NewsCategory, string> = {
  news: "影视新闻",
  review: "影视评论",
  industry: "行业报道",
};

export const news: NewsItem[] = [
  {
    id: "news-changye-dingdang",
    title: "《长夜将明》定档国庆 科幻悬疑新作引期待",
    category: "news",
    author: "影讯速递 · 林一",
    date: "2025-09-18",
    summary:
      "备受关注的科幻悬疑片《长夜将明》正式宣布定档，主创团队亮相发布会，分享影片在视觉与叙事上的全新尝试。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20feature%20image%20of%20a%20press%20conference%20stage%20with%20dramatic%20navy%20blue%20lighting%20and%20warm%20spotlights%2C%20film%20industry%20atmosphere%2C%20elegant%20minimalist%20composition%2C%20premium%20editorial%20photography%2C%20soft%20shadows&width=800&height=500&seq=news-01&orientation=landscape",
    content: [
      "科幻悬疑电影《长夜将明》正式宣布定档，将于国庆假期与观众见面。影片围绕一场持续三百年的长夜展开，讲述天文学家在末日边缘寻找真相的故事。",
      "在发布会上，导演沈之远表示，团队花了近两年时间打磨视效与世界观，希望让观众在享受大银幕奇观的同时，也能感受到故事背后关于希望与坚持的力量。",
      "主演陆时年透露，为了呈现角色的疲惫与执着，他在拍摄前专门与科研工作者交流，观察他们真实的工作状态与思维方式。",
      "片方同步发布了终极预告与一组全新剧照，画面中深蓝与橙色交织的光影风格令人印象深刻。业内人士普遍看好该片在国庆档的表现。",
      "《长夜将明》由多家公司联合出品，影片时长约 138 分钟。（以上为虚构演示资讯）",
    ],
    tags: ["定档", "长夜将明", "科幻"],
  },
  {
    id: "news-changan-season2",
    title: "年度高分剧集《长安十二时》第二季官宣开拍",
    category: "news",
    author: "剧集观察 · 苏禾",
    date: "2025-08-02",
    summary:
      "口碑与热度双丰收的《长安十二时》正式宣布启动第二季，原班主创回归，故事将把镜头对准新的十二时辰。",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20chinese%20lantern%20lit%20city%20street%20at%20night%20with%20warm%20golden%20glow%20and%20deep%20navy%20sky%2C%20cinematic%20editorial%20feature%20image%2C%20elegant%20atmospheric%20composition%2C%20premium%20photography%2C%20soft%20haze&width=800&height=500&seq=news-02&orientation=landscape",
    content: [
      "凭借扎实的剧本与精良制作收获高口碑的《长安十二时》，今日正式官宣第二季启动拍摄。主创团队表示，新一季将延续单元节奏，同时展开更宏大的世界观。",
      "制片人透露，第二季会引入新的势力与谜题，但仍坚持“小人物在大时代中做出选择”的核心表达，这也是第一季打动观众的关键。",
      "主演阵容方面，观众熟悉的多位角色将悉数回归，同时会有几位实力派演员新加盟饰演关键人物。",
      "平台方表示，第二季预计将于明年与观众见面，具体上线时间与集数尚未公布。（以上为虚构演示资讯）",
    ],
    tags: ["长安十二时", "第二季", "开拍"],
  },
  {
    id: "news-filmfestival",
    title: "国际电影节落幕 华语影片斩获多项大奖",
    category: "news",
    author: "视野报道 · 陈澜",
    date: "2025-06-28",
    summary:
      "本届国际电影节正式闭幕，多部华语影片在最佳导演、最佳摄影等单元中获奖，成为红毯之外最受关注的话题。",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20film%20festival%20award%20ceremony%20stage%20with%20golden%20trophy%20and%20deep%20navy%20blue%20curtains%2C%20warm%20elegant%20lighting%2C%20cinematic%20editorial%20feature%20image%2C%20minimalist%20composition%2C%20premium%20photography&width=800&height=500&seq=news-03&orientation=landscape",
    content: [
      "为期十天的国际电影节圆满落下帷幕。本届电影节共收到来自全球的数百部作品，其中多部华语影片入围主竞赛单元。",
      "最终，一部关注普通人生活的剧情片摘得最佳导演奖，评委会盛赞其“以克制的镜头语言，拍出了时代的温度”。此外，两部华语作品分别在最佳摄影与最佳原创音乐单元获奖。",
      "影评人指出，近年来华语影片在国际舞台上的表现愈发多元，既有取材现实的人文关怀，也有类型化叙事的成熟探索。",
      "闭幕式上，多位获奖者表示，希望未来能有更多作品走向世界，把属于东方的情感与美学讲给更多人听。（以上为虚构演示资讯）",
    ],
    tags: ["电影节", "华语影片", "获奖"],
  },
  {
    id: "review-xingji-huixiang",
    title: "影评｜《星际回响》：在浩瀚宇宙中寻找人性的微光",
    category: "review",
    author: "银幕笔记 · 顾南舟",
    date: "2025-07-05",
    summary:
      "《星际回响》用宏大的宇宙图景包裹了一个关于孤独的温柔故事。它真正想讨论的，或许从来都不是星际旅行，而是我们如何面对沉默。",
    cover:
      "https://readdy.ai/api/search-image?query=Vast%20deep%20space%20with%20a%20distant%20glowing%20starship%20and%20swirling%20galaxy%20in%20deep%20navy%20blue%20and%20warm%20orange%20tones%2C%20cinematic%20editorial%20feature%20image%2C%20elegant%20minimalist%20composition%2C%20premium%20photography&width=800&height=500&seq=review-01&orientation=landscape",
    content: [
      "《星际回响》开场便抛出它最大的野心：一支深空探索队在远离地球的星域，收到了一段重复了千年的信号。",
      "影片没有急着展示外星文明的奇观，反而把大量篇幅留给了“等待”。在漫长的沉默里，角色的恐惧、渴望与和解被一层层剥开。这种克制，恰恰是它最动人的地方。",
      "视觉上，深蓝与橙色的强烈对比贯穿全片，冰冷的宇宙与温暖的回忆交替出现，形成了一种几乎可以触摸的孤独感。",
      "当然，影片并非没有缺点，中段节奏略显拖沓，个别支线的收束也稍显仓促。但瑕不掩瑜，它依然是近年少见的、愿意把科幻当作情感载体的作品。",
      "如果要给《星际回响》一句话评价，那大概是：它讲的不是我们如何抵达星辰，而是我们如何在无边的寂静里，依然选择回应。（以上为虚构演示评论）",
    ],
    tags: ["影评", "星际回响", "科幻"],
  },
  {
    id: "review-quanyou",
    title: "剧评｜《权游新纪元》为何能成为现象级作品",
    category: "review",
    author: "剧评人 · 白音",
    date: "2025-05-22",
    summary:
      "从一部奇幻剧集到全民话题，《权游新纪元》靠的不只是宏大的世界观，更是对权力、忠诚与选择这些永恒命题的诚恳追问。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20castle%20on%20a%20cliff%20above%20stormy%20seas%20under%20deep%20navy%20blue%20storm%20clouds%20with%20warm%20torchlight%2C%20cinematic%20editorial%20feature%20image%2C%20dramatic%20atmospheric%20composition%2C%20premium%20photography&width=800&height=500&seq=review-02&orientation=landscape",
    content: [
      "《权游新纪元》开播即刷屏，但真正让它成为现象级的，并不是那些耗资巨大的战争场面，而是它对“人”的刻画。",
      "剧中没有绝对的正邪，每个角色都在自己的立场上做出选择，也在为选择付出代价。权力像一场没有终点的棋局，而真正被考验的，是每个人心里的那条底线。",
      "群像塑造是这部剧最大的优势。无论是背负预言的祭司，还是厌倦家名的私生子，都有着清晰的动机与成长弧线，让庞大的世界观始终落回到具体的人身上。",
      "当然，快速铺开的支线也让部分观众感到信息量过载，这或许是大体量叙事的通病。但只要后续能稳住节奏，它完全有机会走得更远。",
      "在类型剧扎堆的当下，《权游新纪元》提醒我们：观众从未厌倦史诗，他们只是在等待一个真诚的故事。（以上为虚构演示评论）",
    ],
    tags: ["剧评", "权游新纪元", "奇幻"],
  },
  {
    id: "review-shanhe",
    title: "影评｜《山河故人录》——写给时代的一封长信",
    category: "review",
    author: "银幕笔记 · 顾南舟",
    date: "2024-06-01",
    summary:
      "《山河故人录》没有跌宕的情节，却用一封封未曾寄出的家书，把半个世纪的中国家庭史讲得深情而克制。",
    cover:
      "https://readdy.ai/api/search-image?query=Vast%20misty%20mountains%20at%20golden%20dawn%20with%20a%20tiny%20lone%20figure%2C%20deep%20navy%20blue%20shadows%20and%20warm%20orange%20light%2C%20cinematic%20editorial%20feature%20image%2C%20elegant%20minimalist%20composition%2C%20premium%20photography&width=800&height=500&seq=review-03&orientation=landscape",
    content: [
      "如果要用一个词形容《山河故人录》，那大概是“慢”。它不着急，也不煽情，只是安静地把一家三代人的命运铺展开来。",
      "影片的叙事线索是一封封未曾寄出的家书。这些信从未抵达收信人手中，却承载了写信人最真实的牵挂。镜头在信纸上停留的每一秒，都像一次克制的呼吸。",
      "演员的表演同样值得称道，尤其是几位老戏骨，把那种“想说的话到嘴边又咽回去”的隐忍拿捏得恰到好处。",
      "它或许不是一部适合所有人、节奏明快的电影，但对于愿意静下心来的人来说，它是一次难得的、与时代和亲情的对话。",
      "散场时，很多观众久久没有起身。也许每个人都在这封信里，读到了自己家人的影子。（以上为虚构演示评论）",
    ],
    tags: ["影评", "山河故人录", "剧情"],
  },
  {
    id: "industry-streaming",
    title: "流媒体大战升级 各大平台加码自制内容",
    category: "industry",
    author: "产经观察 · 方哲",
    date: "2025-04-16",
    summary:
      "随着用户增长逐渐见顶，各大流媒体平台不约而同地把重心转向自制内容，一场围绕优质剧集的军备竞赛正在加速。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20control%20room%20with%20large%20glowing%20screens%20in%20deep%20navy%20blue%20and%20warm%20orange%20accents%2C%20cinematic%20editorial%20feature%20image%2C%20clean%20minimalist%20composition%2C%20premium%20photography&width=800&height=500&seq=industry-01&orientation=landscape",
    content: [
      "过去一年，各大流媒体平台的用户增速明显放缓，单纯依靠版权采购拉新的策略正逐渐失效，自制内容成为新的竞争焦点。",
      "据行业观察，头部平台今年的自制剧数量较去年增长了约三成，题材也从过去集中于都市情感，进一步扩展到悬疑、科幻、历史等多元类型。",
      "加码自制意味着更高的投入，也意味着更大的风险。一部剧的成败，往往能直接影响平台一个季度的用户留存表现。",
      "有分析师指出，未来竞争的关键或许不在于“谁的内容多”，而在于“谁更懂用户”。精细化运营与差异化定位，将成为平台破局的核心。",
      "这场没有硝烟的内容大战，最终受益的也许正是坐在屏幕前的观众。（以上为虚构演示资讯）",
    ],
    tags: ["流媒体", "自制内容", "行业"],
  },
  {
    id: "industry-boxoffice",
    title: "电影市场复苏 暑期档票房创近年新高",
    category: "industry",
    author: "产经观察 · 方哲",
    date: "2025-08-28",
    summary:
      "在多重利好因素推动下，本年度暑期档票房表现亮眼，多部类型片口碑票房双收，市场信心明显回升。",
    cover:
      "https://readdy.ai/api/search-image?query=Crowded%20modern%20cinema%20lobby%20with%20warm%20golden%20lights%20and%20deep%20navy%20blue%20movie%20posters%2C%20cinematic%20editorial%20feature%20image%2C%20elegant%20atmospheric%20composition%2C%20premium%20photography&width=800&height=500&seq=industry-02&orientation=landscape",
    content: [
      "本年度暑期档正式收官，整体票房成绩超出市场预期，创下近年来的新高，为行业注入了一针强心剂。",
      "从题材分布看，科幻、悬疑、动画等类型片表现突出，多部作品实现了口碑与票房的双赢，说明观众对优质内容的付费意愿正在回升。",
      "业内认为，票房的复苏不仅得益于供给端的丰富，也与观影习惯的回暖、档期运营的成熟密切相关。",
      "不过也有声音提醒，市场集中度依然偏高，中小成本影片的生存空间仍有待改善，行业复苏还需要更长时间来验证。（以上为虚构演示资讯）",
    ],
    tags: ["票房", "暑期档", "行业"],
  },
  {
    id: "industry-ai",
    title: "AI技术入局影视制作 行业迎来新变革",
    category: "industry",
    author: "技术前沿 · 沈墨",
    date: "2025-03-11",
    summary:
      "从剧本辅助到后期视效，人工智能正以越来越深的程度介入影视制作流程，效率提升的同时也带来了新的讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20film%20editing%20studio%20with%20holographic%20screens%20and%20deep%20navy%20blue%20ambient%20light%20with%20warm%20orange%20accents%2C%20cinematic%20editorial%20feature%20image%2C%20clean%20minimalist%20composition%2C%20premium%20photography&width=800&height=500&seq=industry-03&orientation=landscape",
    content: [
      "人工智能正在悄然改变影视行业的制作方式。从剧本打磨、分镜预演，到后期剪辑与视效渲染，AI 工具的身影越来越常见。",
      "多家制作公司表示，AI 的介入显著缩短了部分环节的制作周期，也让中小团队有机会实现过去只有大制作才能完成的视觉效果。",
      "但技术从来都是一把双刃剑。关于创作主体性、版权归属与从业者就业的讨论，也随之成为行业热点。",
      "多数受访从业者认为，AI 更像是工具而非替代者，真正决定作品水准的，依然是人的审美与表达。如何用好这把工具，是整个行业需要共同面对的课题。（以上为虚构演示资讯）",
    ],
    tags: ["AI", "影视制作", "技术"],
  },
  {
    id: "news-anye-boxoffice",
    title: "《暗夜追凶》全球票房破十亿 悬疑题材再受关注",
    category: "news",
    author: "影讯速递 · 林一",
    date: "2024-12-05",
    summary:
      "悬疑犯罪片《暗夜追凶》全球票房正式突破十亿大关，成为本年度最受欢迎的悬疑作品之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20rainy%20city%20street%20at%20night%20with%20a%20single%20glowing%20streetlamp%20and%20deep%20navy%20blue%20tones%2C%20cinematic%20editorial%20feature%20image%2C%20moody%20atmospheric%20composition%2C%20premium%20photography&width=800&height=500&seq=news-04&orientation=landscape",
    content: [
      "悬疑犯罪电影《暗夜追凶》全球票房正式突破十亿，成为本年度表现最亮眼的类型片之一。",
      "影片凭借缜密的剧本与层层反转的叙事，在观众中收获了极高口碑，社交平台上关于结局的讨论持续多日。",
      "导演表示，创作过程中团队最看重的就是“合理性”，每一个反转都必须能在前文找到伏笔，让观众在复盘时感到惊喜而非被戏弄。",
      "业内认为，该片的成功再次证明，扎实的类型化叙事依然拥有广阔的市场空间。（以上为虚构演示资讯）",
    ],
    tags: ["暗夜追凶", "票房", "悬疑"],
  },
  {
    id: "news-wudu-ip",
    title: "经典IP重启 《雾都谜案》确认开发剧集版",
    category: "news",
    author: "剧集观察 · 苏禾",
    date: "2025-02-20",
    summary:
      "口碑电影《雾都谜案》确认将开发剧集版本，原电影编剧参与创作，计划以更长篇幅铺展雾都世界的群像故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20victorian%20clock%20tower%20above%20foggy%20cobblestone%20street%20at%20night%20with%20warm%20gas%20lamps%2C%20deep%20navy%20blue%20mist%2C%20cinematic%20editorial%20feature%20image%2C%20moody%20atmospheric%20composition&width=800&height=500&seq=news-05&orientation=landscape",
    content: [
      "曾收获高口碑的悬疑电影《雾都谜案》正式确认开发剧集版，消息一出便引发原著影迷的热烈讨论。",
      "据悉，剧集版将邀请原电影编剧深度参与创作，以更长的篇幅去铺展电影中未能充分展开的世界观与人物关系。",
      "与电影聚焦单一案件不同，剧集版计划采用单元案件串起主线的方式，让观众在每一集都能获得完整的推理体验。",
      "制作方表示，剧集将在保留原作复古悬疑质感的基础上，进一步丰富时代细节与群像刻画。具体上线时间尚未公布。（以上为虚构演示资讯）",
    ],
    tags: ["雾都谜案", "IP", "剧集"],
  },
  {
    id: "review-shouer",
    title: "剧评｜《首尔恋爱公式》：轻盈治愈的都市童话",
    category: "review",
    author: "剧评人 · 白音",
    date: "2025-06-10",
    summary:
      "《首尔恋爱公式》没有复杂的情节，却用清爽的节奏和可爱的角色，讲了一个让人放松下来的小故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20seoul%20cafe%20street%20in%20autumn%20with%20warm%20streetlights%20and%20falling%20leaves%2C%20deep%20navy%20blue%20dusk%20sky%2C%20cinematic%20editorial%20feature%20image%2C%20warm%20minimalist%20composition%2C%20premium%20photography&width=800&height=500&seq=review-04&orientation=landscape",
    content: [
      "如果你最近有点累，《首尔恋爱公式》大概是一剂恰到好处的甜品。它不追求烧脑，也不刻意制造狗血冲突，只是安静地讲一个甜美的故事。",
      "剧集的核心设定相当讨巧：一个坚信恋爱能用公式计算的数学老师，遇见了一个把人生过成随机数的吉他手。理性与感性的碰撞，构成了主要的笑点与看点。",
      "两位主演的化学反应自然，台词轻快不油腻，配乐与画面也保持了很高的舒适度，秋日街道的暖色调尤其治愈。",
      "当然，它并非没有套路，部分情节依旧走在熟悉的安全线上。但作为一部下饭剧，它完成了自己的使命——让人在忙碌之余，轻松地笑一笑。",
      "有时候，我们需要的正是这样一部不费力的作品，陪我们度过一个温柔的夜晚。（以上为虚构演示评论）",
    ],
    tags: ["剧评", "首尔恋爱公式", "爱情"],
  },
];

export const newsCategories: { value: NewsCategory | "all"; label: string }[] = [
  { value: "all", label: "全部" },
  { value: "news", label: "影视新闻" },
  { value: "review", label: "影视评论" },
  { value: "industry", label: "行业报道" },
];